(function () {
  'use strict';

  const root = document.querySelector('[data-sf-wizard]');
  if (!root) return;

  const cfg = {
    productId: root.dataset.productId,
    productHandle: root.dataset.productHandle,
    variantId: root.dataset.variantId,
    productTitle: root.dataset.productTitle,
    zoneName: root.dataset.zoneName || '',
  };

  const i18nEl = root.querySelector('[data-sf-wizard-i18n]');
  const i18n = (() => {
    if (!i18nEl) return {};
    try {
      return JSON.parse(i18nEl.textContent || '{}');
    } catch (err) {
      return {};
    }
  })();
  function tr(key, vars = {}) {
    const fallback = {
      familyNameLabel: 'Kişi {{ index }} Ad Soyad',
      familyNamePlaceholder: 'Ad Soyad',
      chooseStarTypeError: 'Lütfen bir yıldız tipi seçiniz.',
      fullNameError: 'Lütfen ad soyad giriniz.',
      max30Error: 'En fazla 30 karakter.',
      personCountError: 'Lütfen kişi sayısı seçiniz.',
      allNamesError: 'Tüm isim alanlarını doldurun.',
      personRangeError: 'Lütfen kişi aralığını seçiniz.',
      companyError: 'Lütfen şirket / kurum adını giriniz.',
      missingOrderError: 'Sipariş bilgileri eksik. Lütfen tekrar deneyin.',
      individualQuantityError: 'Bireysel yıldız için adet 1 olmalıdır.',
      addingToCart: 'Sepete ekleniyor...',
      nextStep: 'Sonraki Adım',
      addError: 'Sepete eklenirken bir hata oluştu.',
      upsellTitle: 'Yıldızınla birlikte tercih edilenler',
      upsellLead: 'Yıldızını kişiye özel ürünlerle tamamlayabilirsin.',
      upsellAddSelected: 'Seçili ürünleri ekle',
      upsellAddSelectedCount: 'Seçili ürünleri ekle ({{ count }})',
      upsellSkip: 'Sadece yıldızımı al',
      upsellSelectProduct: 'Ürünü seç',
      upsellVariantLabel: 'Seçenek',
      upsellAvailable: 'Eklenebilir',
      upsellUnavailable: 'Tükendi',
    };
    return String(i18n[key] || fallback[key] || '')
      .replace(/{{\s*index\s*}}/g, vars.index == null ? '' : String(vars.index))
      .replace(/{{\s*count\s*}}/g, vars.count == null ? '' : String(vars.count))
      .replace(/__COUNT__/g, vars.count == null ? '' : String(vars.count));
  }

  const upsellsEl = root.querySelector('[data-sf-upsells]');
  const upsellProducts = (() => {
    if (!upsellsEl) return [];
    try {
      const parsed = JSON.parse(upsellsEl.textContent || '[]');
      return Array.isArray(parsed) ? parsed.filter((product) => product && product.variants?.length) : [];
    } catch (err) {
      return [];
    }
  })();

  const form = root.querySelector('[data-sf-form]');
  const stepper = root.querySelectorAll('.sf-stepper__item');
  const tipiRadios = root.querySelectorAll('[data-sf-tipi]');
  const customizeBtn = root.querySelector('[data-sf-customize]');
  const customizeSection = root.querySelector('[data-sf-customize-section]');
  const backBtn = root.querySelector('[data-sf-back]');
  const infoSection = root.querySelector('[data-sf-info]');
  const mainImg = root.querySelector('[data-sf-main-img]');
  const thumbs = root.querySelectorAll('[data-sf-thumb]');
  const upsellModal = root.querySelector('[data-sf-upsell-modal]');
  const upsellList = root.querySelector('[data-sf-upsell-list]');
  const upsellAddBtn = root.querySelector('[data-sf-upsell-add]');
  const upsellSkipBtn = root.querySelector('[data-sf-upsell-skip]');

  // ---------- State transitions (info <-> customize) ----------
  const STEP_PARAM = 'step';
  const STEP_VALUE = 'customize';

  function showCustomize(opts = {}) {
    if (!customizeSection) return;
    root.dataset.sfState = 'customize';
    customizeSection.hidden = false;
    if (opts.scroll !== false) {
      setTimeout(() => {
        customizeSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 50);
    }
  }

  function showInfo(opts = {}) {
    if (!customizeSection) return;
    root.dataset.sfState = 'info';
    customizeSection.hidden = true;
    if (opts.scroll !== false && infoSection) {
      setTimeout(() => {
        infoSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 50);
    }
  }

  function pushUrlState(stateValue) {
    const url = new URL(window.location.href);
    if (stateValue === 'customize') {
      url.searchParams.set(STEP_PARAM, STEP_VALUE);
    } else {
      url.searchParams.delete(STEP_PARAM);
    }
    history.pushState({ sf: stateValue }, '', url.toString());
  }

  // Customize button: open wizard + push URL state
  if (customizeBtn && customizeSection) {
    customizeBtn.addEventListener('click', () => {
      showCustomize();
      pushUrlState('customize');
    });
  }

  // Back button: close wizard + clear URL state
  if (backBtn && customizeSection) {
    backBtn.addEventListener('click', () => {
      showInfo();
      pushUrlState('info');
    });
  }

  // Browser back/forward: sync state from URL
  window.addEventListener('popstate', () => {
    const params = new URLSearchParams(window.location.search);
    if (params.get(STEP_PARAM) === STEP_VALUE) {
      showCustomize({ scroll: false });
    } else {
      showInfo({ scroll: false });
    }
  });

  // On initial load: if URL already has ?step=customize, open the wizard
  (function initFromUrl() {
    const params = new URLSearchParams(window.location.search);
    if (params.get(STEP_PARAM) === STEP_VALUE) {
      showCustomize({ scroll: false });
    }
  })();

  // ---------- Thumbnail click: swap main image ----------
  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const src = thumb.dataset.src;
      if (mainImg && src) {
        mainImg.style.opacity = '0';
        setTimeout(() => {
          mainImg.src = src;
          mainImg.style.opacity = '1';
        }, 150);
      }
      thumbs.forEach((t) => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });
  const panels = {
    bireysel: root.querySelector('[data-sf-panel="bireysel"]'),
    aile: root.querySelector('[data-sf-panel="aile"]'),
    kurumsal: root.querySelector('[data-sf-panel="kurumsal"]'),
  };
  const aileCount = root.querySelector('[data-sf-aile-count]');
  const aileNamesWrap = root.querySelector('[data-sf-aile-names]');
  const starName = root.querySelector('[data-sf-star-name]');
  const submitBtn = root.querySelector('[data-sf-submit]');
  let isAdding = false;
  let pendingProperties = null;
  const selectedUpsells = new Map();

  // ---------- Step 1: yıldız tipi panel switching ----------
  tipiRadios.forEach((r) => {
    r.addEventListener('change', () => {
      Object.entries(panels).forEach(([key, panel]) => {
        if (!panel) return;
        if (key === r.value) {
          panel.hidden = false;
        } else {
          panel.hidden = true;
        }
      });
      updateStarPreview();
      clearError('yildiz_tipi');
    });
  });

  // ---------- Aile: dynamic name inputs ----------
  if (aileCount && aileNamesWrap) {
    aileCount.addEventListener('change', () => {
      const n = parseInt(aileCount.value, 10);
      aileNamesWrap.innerHTML = '';
      if (!n || isNaN(n)) return;
      for (let i = 1; i <= n; i++) {
        const wrap = document.createElement('label');
        wrap.className = 'sf-field';
        wrap.innerHTML = `
          <span class="sf-field__label">${tr('familyNameLabel', { index: i })}</span>
          <input type="text" name="aile_ad_soyad_${i}" data-sf-aile-name="${i}" maxlength="30" placeholder="${tr('familyNamePlaceholder')}" autocomplete="off">
        `;
        aileNamesWrap.appendChild(wrap);
      }
      // First aile name drives the live preview
      const first = aileNamesWrap.querySelector('[data-sf-aile-name="1"]');
      if (first) {
        first.addEventListener('input', updateStarPreview);
      }
      updateStarPreview();
      clearError('aile_kisi_sayisi');
    });
  }

  // ---------- Live star name preview ----------
  function updateStarPreview() {
    const tipi = getTipi();
    let val = '';
    if (tipi === 'bireysel') {
      const i = root.querySelector('[name="bireysel_ad_soyad"]');
      val = i ? i.value : '';
    } else if (tipi === 'aile') {
      const i = root.querySelector('[data-sf-aile-name="1"]');
      val = i ? i.value : '';
    } else if (tipi === 'kurumsal') {
      const i = root.querySelector('[name="kurumsal_sirket"]');
      val = i ? i.value : '';
    }
    if (starName) {
      // Each word on its own line
      starName.textContent = val.trim().split(/\s+/).filter(Boolean).join('\n');
    }
  }
  // Bind input listeners on text fields
  root.querySelectorAll('[data-sf-name-source]').forEach((el) => {
    el.addEventListener('input', updateStarPreview);
  });

  function getTipi() {
    const checked = root.querySelector('[data-sf-tipi]:checked');
    return checked ? checked.value : null;
  }

  // ---------- Validation ----------
  function showError(key, msg) {
    const el = root.querySelector(`[data-sf-error="${key}"]`);
    if (el) { el.textContent = msg; window.StarfanDL?.error('form_hatasi', msg, 'urun_detay'); }
  }
  function clearError(key) {
    const el = root.querySelector(`[data-sf-error="${key}"]`);
    if (el) el.textContent = '';
  }
  function clearAllErrors() {
    root.querySelectorAll('[data-sf-error]').forEach((e) => (e.textContent = ''));
  }

  function validate() {
    clearAllErrors();
    const tipi = getTipi();
    if (!tipi) {
      showError('yildiz_tipi', tr('chooseStarTypeError'));
      return false;
    }

    if (tipi === 'bireysel') {
      const v = root.querySelector('[name="bireysel_ad_soyad"]').value.trim();
      if (!v) {
        showError('bireysel_ad_soyad', tr('fullNameError'));
        return false;
      }
      if (v.length > 30) {
        showError('bireysel_ad_soyad', tr('max30Error'));
        return false;
      }
    }

    if (tipi === 'aile') {
      const n = parseInt(aileCount.value, 10);
      if (!n) {
        showError('aile_kisi_sayisi', tr('personCountError'));
        return false;
      }
      const inputs = aileNamesWrap.querySelectorAll('input[type="text"]');
      for (const inp of inputs) {
        if (!inp.value.trim()) {
          showError('aile_kisi_sayisi', tr('allNamesError'));
          return false;
        }
      }
    }

    if (tipi === 'kurumsal') {
      const aralik = root.querySelector('[name="kurumsal_aralik"]:checked');
      if (!aralik) {
        showError('kurumsal_aralik', tr('personRangeError'));
        return false;
      }
      const sirket = root.querySelector('[name="kurumsal_sirket"]').value.trim();
      if (!sirket) {
        showError('kurumsal_sirket', tr('companyError'));
        return false;
      }
    }

    return true;
  }

  // ---------- Build line item properties ----------
  //
  // Property keys are written in Turkish so they render correctly on Shopify's
  // checkout summary (which displays raw key names — theme Liquid cannot customize
  // checkout). Backend readers (scripts/lib/star-name.mjs, Make Scenario 1,
  // Shopify Flow starfan-order-init) all have fallback chains that accept both
  // ASCII (legacy v2-ascii-keys) and Turkish keys.
  // Internal-only keys are underscore-prefixed so Shopify hides them everywhere.
  function buildProperties() {
    const tipi = getTipi();
    const tipiLabel = { bireysel: 'Bireysel', aile: 'Aile', kurumsal: 'Kurumsal' }[tipi] || tipi;
    const props = {
      _source_version: 'v3-turkish-keys',
      'Yıldız Tipi': tipiLabel,
      'Bölge': cfg.zoneName || '',
    };

    if (tipi === 'bireysel') {
      props['Yıldız Adı'] = root.querySelector('[name="bireysel_ad_soyad"]').value.trim();
    } else if (tipi === 'aile') {
      const n = parseInt(aileCount.value, 10);
      props['Kişi Sayısı'] = String(n);
      const inputs = aileNamesWrap.querySelectorAll('input[type="text"]');
      inputs.forEach((inp, idx) => {
        props[`Yıldız Adı ${idx + 1}`] = inp.value.trim();
      });
    } else if (tipi === 'kurumsal') {
      props['Kurumsal Kişi Aralığı'] = root.querySelector('[name="kurumsal_aralik"]:checked').value;
      props['Şirket Adı'] = root.querySelector('[name="kurumsal_sirket"]').value.trim();
    }

    return props;
  }

  function resolveMainQuantity() {
    const tipi = getTipi();
    if (tipi === 'aile') {
      const n = parseInt(aileCount.value, 10);
      return Number.isFinite(n) && n > 0 ? n : 1;
    }
    return 1;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function firstDisplayVariant(product) {
    return product.variants.find((variant) => variant.available) || product.variants[0] || null;
  }

  function variantById(product, variantId) {
    return product.variants.find((variant) => String(variant.id) === String(variantId)) || firstDisplayVariant(product);
  }

  function productHasAvailableVariant(product) {
    return product.variants.some((variant) => variant.available);
  }

  function resolvePersonalizedName(properties) {
    return String(
      properties?.['Yıldız Adı'] ||
      properties?.['Şirket Adı'] ||
      properties?.['Yıldız Adı 1'] ||
      ''
    ).trim();
  }

  function updateUpsellAddButton() {
    if (!upsellAddBtn) return;
    const count = selectedUpsells.size;
    upsellAddBtn.disabled = isAdding || count === 0;
    upsellAddBtn.textContent = count > 0
      ? tr('upsellAddSelectedCount', { count })
      : tr('upsellAddSelected');
  }

  function syncUpsellCardState(card, product, variantId) {
    const variant = variantById(product, variantId);
    const checkbox = card.querySelector('[data-sf-upsell-checkbox]');
    const price = card.querySelector('[data-sf-upsell-price]');
    const badge = card.querySelector('[data-sf-upsell-badge]');
    const canSelect = Boolean(variant?.available);

    card.dataset.selectedVariantId = variant?.id || '';
    card.classList.toggle('is-unavailable', !canSelect);
    if (checkbox) {
      checkbox.disabled = !canSelect || isAdding;
      if (!canSelect) checkbox.checked = false;
    }
    if (price) price.textContent = variant?.priceFormatted || '';
    if (badge) {
      badge.textContent = canSelect ? tr('upsellAvailable') : tr('upsellUnavailable');
      badge.classList.toggle('is-unavailable', !canSelect);
    }
    if (!canSelect) {
      selectedUpsells.delete(product.handle);
    } else if (checkbox?.checked) {
      selectedUpsells.set(product.handle, { product, variantId: variant.id });
    }
    updateUpsellAddButton();
  }

  function setUpsellSelected(card, product, selected) {
    const checkbox = card.querySelector('[data-sf-upsell-checkbox]');
    const variant = variantById(product, card.dataset.selectedVariantId);
    if (!variant?.available || isAdding) return;

    if (checkbox) checkbox.checked = selected;
    card.classList.toggle('is-selected', selected);
    if (selected) {
      selectedUpsells.set(product.handle, { product, variantId: variant.id });
    } else {
      selectedUpsells.delete(product.handle);
    }
    updateUpsellAddButton();
  }

  function renderUpsellProducts() {
    if (!upsellList || !upsellProducts.length) return;
    upsellList.innerHTML = '';

    upsellProducts.forEach((product) => {
      const displayVariant = firstDisplayVariant(product);
      const canSelectProduct = productHasAvailableVariant(product);
      const card = document.createElement('article');
      card.className = `sf-upsell-card${canSelectProduct ? '' : ' is-unavailable'}`;
      card.dataset.productHandle = product.handle;
      card.dataset.selectedVariantId = displayVariant?.id || '';

      const variantOptions = product.variants.map((variant) => `
        <option value="${escapeHtml(variant.id)}"${variant.available ? '' : ' disabled'}${displayVariant && String(variant.id) === String(displayVariant.id) ? ' selected' : ''}>
          ${escapeHtml(variant.title)}${variant.available ? '' : ` - ${tr('upsellUnavailable')}`}
        </option>
      `).join('');
      const showVariantPicker = !product.hasOnlyDefaultVariant && product.variants.length > 1;

      card.innerHTML = `
        <div class="sf-upsell-card__media">
          ${product.image ? `<img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.title)}" loading="lazy">` : '<div class="sf-upsell-card__placeholder" aria-hidden="true"></div>'}
        </div>
        <div class="sf-upsell-card__body">
          <div class="sf-upsell-card__top">
            <label class="sf-upsell-card__check">
              <input type="checkbox" data-sf-upsell-checkbox ${canSelectProduct ? '' : 'disabled'}>
              <span aria-hidden="true"></span>
              <span class="visually-hidden">${tr('upsellSelectProduct')}</span>
            </label>
            <div class="sf-upsell-card__copy">
              <h3 class="sf-upsell-card__title">${escapeHtml(product.title)}</h3>
              <p class="sf-upsell-card__price" data-sf-upsell-price>${escapeHtml(displayVariant?.priceFormatted || '')}</p>
            </div>
            <span class="sf-upsell-card__badge${canSelectProduct ? '' : ' is-unavailable'}" data-sf-upsell-badge>${canSelectProduct ? tr('upsellAvailable') : tr('upsellUnavailable')}</span>
          </div>
          ${showVariantPicker ? `
            <label class="sf-upsell-card__variant">
              <span>${tr('upsellVariantLabel')}</span>
              <select data-sf-upsell-variant ${canSelectProduct ? '' : 'disabled'}>
                ${variantOptions}
              </select>
            </label>
          ` : ''}
        </div>
      `;

      const checkbox = card.querySelector('[data-sf-upsell-checkbox]');
      const variantSelect = card.querySelector('[data-sf-upsell-variant]');

      card.addEventListener('click', (event) => {
        if (!canSelectProduct || isAdding) return;
        if (event.target.closest('select')) return;
        if (event.target.closest('[data-sf-upsell-checkbox]')) {
          setUpsellSelected(card, product, checkbox.checked);
          return;
        }
        setUpsellSelected(card, product, !checkbox.checked);
      });

      if (variantSelect) {
        variantSelect.addEventListener('change', () => {
          syncUpsellCardState(card, product, variantSelect.value);
        });
      }

      syncUpsellCardState(card, product, displayVariant?.id);
      upsellList.appendChild(card);
    });
  }

  function resetUpsellSelection() {
    selectedUpsells.clear();
    root.querySelectorAll('.sf-upsell-card').forEach((card) => {
      card.classList.remove('is-selected');
      const checkbox = card.querySelector('[data-sf-upsell-checkbox]');
      if (checkbox) checkbox.checked = false;
    });
    updateUpsellAddButton();
  }

  function openUpsellModal() {
    if (!upsellModal || !upsellProducts.length) return false;
    resetUpsellSelection();
    upsellModal.hidden = false;
    upsellModal.setAttribute('aria-hidden', 'false');
    window.StarfanDL?.upsell(upsellProducts);
    document.documentElement.classList.add('sf-upsell-is-open');
    document.body.classList.add('sf-upsell-is-open');
    setTimeout(() => {
      const focusTarget = upsellModal.querySelector('[data-sf-upsell-checkbox]:not(:disabled), [data-sf-upsell-skip]');
      if (focusTarget) focusTarget.focus();
    }, 0);
    return true;
  }

  function closeUpsellModal() {
    if (!upsellModal) return;
    upsellModal.hidden = true;
    upsellModal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('sf-upsell-is-open');
    document.body.classList.remove('sf-upsell-is-open');
  }

  function buildUpsellItems(propertiesSnapshot) {
    return Array.from(selectedUpsells.values()).map(({ product, variantId }) => {
      const item = {
        id: parseInt(variantId, 10),
        quantity: 1,
      };
      if (product.requiresPersonalization) {
        const personalizedName = resolvePersonalizedName(propertiesSnapshot);
        if (personalizedName) {
          item.properties = { 'İsim': personalizedName };
        }
      }
      return item;
    });
  }

  renderUpsellProducts();

  if (upsellAddBtn) {
    upsellAddBtn.addEventListener('click', () => {
      if (!pendingProperties || selectedUpsells.size === 0) return;
      addToCart(pendingProperties, buildUpsellItems(pendingProperties));
    });
  }

  if (upsellSkipBtn) {
    upsellSkipBtn.addEventListener('click', () => {
      if (!pendingProperties || isAdding) return;
      window.StarfanDL?.skip();
      addToCart(pendingProperties, []);
    });
  }

  // ---------- Submit ----------
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    if (!validate()) return;

    pendingProperties = buildProperties();
    if (!openUpsellModal()) {
      addToCart(pendingProperties, []);
    }
  });

  function setStep(n) {
    stepper.forEach((el) => {
      const step = parseInt(el.dataset.step, 10);
      el.classList.toggle('is-active', step <= n);
    });
  }

  function assertSafeCartPayload(properties, quantity) {
    const tipi = getTipi();
    if (!properties || typeof properties !== 'object') {
      throw new Error(tr('missingOrderError'));
    }
    if (tipi === 'bireysel') {
      if (quantity !== 1) {
        throw new Error(tr('individualQuantityError'));
      }
      if (!String(properties['Yıldız Adı'] || '').trim()) {
        throw new Error(tr('fullNameError'));
      }
    }
    if (tipi === 'aile') {
      const n = parseInt(properties['Kişi Sayısı'], 10);
      if (!Number.isFinite(n) || n < 1) {
        throw new Error(tr('personCountError'));
      }
      for (let index = 1; index <= n; index += 1) {
        if (!String(properties[`Yıldız Adı ${index}`] || '').trim()) {
          throw new Error(tr('allNamesError'));
        }
      }
    }
  }

  // ---------- Add to cart ----------
  async function addToCart(propertiesSnapshot, upsellItems = []) {
    if (isAdding) return;
    if (!validate()) return;

    isAdding = true;
    submitBtn.disabled = true;
    submitBtn.textContent = tr('addingToCart');
    if (upsellAddBtn) upsellAddBtn.disabled = true;
    if (upsellSkipBtn) upsellSkipBtn.disabled = true;

    const properties = propertiesSnapshot || buildProperties();
    const quantity = resolveMainQuantity();
    try {
      assertSafeCartPayload(properties, quantity);
    } catch (err) {
      window.StarfanDL?.error('form_hatasi', err.message, 'urun_detay');
      alert(err.message);
      isAdding = false;
      submitBtn.disabled = false;
      submitBtn.textContent = tr('nextStep');
      if (upsellSkipBtn) upsellSkipBtn.disabled = false;
      updateUpsellAddButton();
      return;
    }

    const items = [
      {
        id: parseInt(cfg.variantId, 10),
        quantity: quantity,
        properties: properties,
      },
      ...upsellItems,
    ];

    try {
      const cartAddUrl = root.dataset.cartAddUrl || '/cart/add.js';
      const cartUrl = root.dataset.cartUrl || (window.location.pathname.startsWith('/en/') ? '/en/cart' : '/cart');
      const res = await fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || tr('addError'));
      }
      const added = await res.json();
      const sources = {};
      for (const entry of selectedUpsells.values()) {
        if (!upsellItems.some(i => String(i.id) === String(entry.variantId))) continue;
        sources[String(entry.variantId)] = {
          item_list_id: 'upsell_customize', item_list_name: 'Yıldızınla birlikte tercih edilenler',
          index: upsellProducts.findIndex(p => p.id === entry.product.id) + 1,
        };
      }
      window.StarfanDL?.added(added, items, sources);
      setStep(2);
      closeUpsellModal();
      window.location.href = cartUrl;
    } catch (err) {
      window.StarfanDL?.error(/stok|stock|sold|tüken/i.test(err.message) ? 'stok_hatasi' : 'sistem_hatasi', err.message, 'urun_detay');
      alert(err.message);
      isAdding = false;
      submitBtn.disabled = false;
      submitBtn.textContent = tr('nextStep');
      if (upsellSkipBtn) upsellSkipBtn.disabled = false;
      updateUpsellAddButton();
    }
  }
})();
